import { useRef } from "react";

import { swaDate } from "@swa-ui/date";
import { logger } from "@swa-ui/log";
import { usePersonas } from "@swa-ui/personas";

import { getApiKey } from "../getApiKey";
import { getChannelId } from "../getChannelId";

export const useApi = (Configuration, Api, basePath) => {
  const { persona } = usePersonas();
  const apiKey = getApiKey();
  const xChannelId = getChannelId(persona);
  const headers = {
    xChannelId,
  };
  const post = onError;
  const apiRef = useRef(
    new Api(
      new Configuration({
        apiKey,
        basePath,
        headers,
        middleware: [
          {
            onError,
            post,
          },
        ],
      })
    )
  );

  return apiRef.current;
};

export async function onError(context) {
  if (!context.response.ok) {
    const callDuration = swaDate(context.date).diff(swaDate());
    const response = context.response.clone();
    const body = await response.json();

    logger.error(`FETCH ERROR ${context.response.statusText}`, { ...body, callDuration });
  }
}
